import {css} from "@emotion/react";

import {rem} from "./utils/rem";

type Size = 0 | 0.5 | 1 | 2 | 3 | 4;

const BASE_SIZE = 0.8;

// multiplies border size by base (0.8rem). Accepts up to 4 arguments for border-radius sides
export const borderRadius = (...sizeArgs: [] | [Size] | [Size, Size, Size, Size]) => {
    const hasAnyBorderRadiusSizes = sizeArgs.length > 0;

    if (hasAnyBorderRadiusSizes) {
        return css`
            border-radius: ${sizeArgs.map((size) => rem(size * BASE_SIZE)).join(" ")};
        `;
    }

    return css`
        border-radius: ${rem(BASE_SIZE)};
    `;
};
import {css} from "@emotion/react";

import {rem} from "./utils/rem";

type Size = 0 | 0.5 | 1 | 2 | 3 | 4;

const BASE_SIZE = 0.8;

// multiplies border size by base (0.8rem). Accepts up to 4 arguments for border-radius sides
export const borderRadius = (...sizeArgs: [] | [Size] | [Size, Size, Size, Size]) => {
    const hasAnyBorderRadiusSizes = sizeArgs.length > 0;

    if (hasAnyBorderRadiusSizes) {
        return css`
            border-radius: ${sizeArgs.map((size) => rem(size * BASE_SIZE)).join(" ")};
        `;
    }

    return css`
        border-radius: ${rem(BASE_SIZE)};
    `;
};
